export const OPTION_VALUES_SERVER = `
  fragment OptionValuesDetails on OptionValue {
    id
    name
    optionTypeId
    position
    presentation
  }
`;
